import React, { Component } from "react";
import { Auth } from "redux-server-connection";

import { connect } from "react-redux";

import Render from "./Render";

class Catalogo extends Component {
  constructor(props) {
    super(props);
    this.state = { user: Auth.getUser() };
  }

  render() {
    return <Render {...this.props} {...this.state} {...this.bindings} />;
  }
}

export default connect()(Catalogo);



// WEBPACK FOOTER //
// ./src/pages/Catalogo/index.js